// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__A8OWj","controller":"styles_controller__u4SBH","list":"styles_list__y-UMS"};